var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoViviendas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.718,
    height: 89.718,
    viewBox: "0 0 89.718 89.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_viviendas",
    transform: "translate(-306 -896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6451",
    "data-name": "Rectangle 6451",
    width: 89.718,
    height: 89.718,
    transform: "translate(306 896)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7964",
    "data-name": "Group 7964",
    transform: "translate(313.874 903.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19216",
    "data-name": "Path 19216",
    d: "M140.057,285.293a6.465,6.465,0,0,0-2.25-4.438l-6.4-5.484V259.787a2.165,2.165,0,0,0-2.166-2.166h-8.669a2.141,2.141,0,0,0-2.137,2.166v4.44l-10.967-9.347a6.466,6.466,0,0,0-8.454-.006L68.38,280.855a6.5,6.5,0,0,0-.7,9.17,6.566,6.566,0,0,0,7.131,1.892v33.169a2.141,2.141,0,0,0,2.137,2.166h52.3a2.165,2.165,0,0,0,2.166-2.166V291.92a6.5,6.5,0,0,0,8.649-6.627Zm-17.318-23.338H127.1v9.7l-4.363-3.714Zm-10.806,60.963H94.28V305.555h17.653Zm4.306,0v-19.5a2.167,2.167,0,0,0-2.166-2.168H92.114a2.143,2.143,0,0,0-2.137,2.168v19.5H79.111V288.8l24.119-20.459L127.1,288.781v34.138ZM135.221,287.2a2.167,2.167,0,0,1-3.057.236l-27.517-23.587a2.167,2.167,0,0,0-2.812-.008L74.022,287.436a2.167,2.167,0,0,1-2.829-3.285l30.633-25.981a2.16,2.16,0,0,1,2.821,0l30.338,25.975A2.168,2.168,0,0,1,135.221,287.2Z",
    transform: "translate(-66.108 -253.304)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoViviendas);
export default __webpack_public_path__ + "static/media/ico_viviendas.5c3e4981e2fda584041bc57f8780a5be.svg";
export { ForwardRef as ReactComponent };